const local = '_PROVIDER_SUBCLASSIFICACAO_FOLLOWAIR_'
import Vue from 'vue'

var update = false

export default {
	methods: {
		_GET_SUBCLASSIFICACAO: function (callback) {
			this._httpGet('/Subclassificacao/lista', function (retorno) {
				if (retorno._request && retorno._status) {
					retorno.lista.map((item) => {
						item._descricao = `${item.subclassificacao.replace(' ', '').replace('.', '')} - ${item.descricao} (${
							item.classificacao
						})`
						item._descricao_completo = `${item.classificacao} - ${item.descricao}`
						return item
					})
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerSubclassificacaoUpdate: function () {
			// ESTADOS
			this._GET_SUBCLASSIFICACAO(function (lista) {
				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerSubclassificacao: function (callback) {
			if (!update) {
				update = true
				this._GET_SUBCLASSIFICACAO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			// se existir config do cliente
			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(sessionStorage.getItem(local)))
			} else {
				this._GET_SUBCLASSIFICACAO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}